

export default function Header(){
    return (
        <header className='flex justify-between px-5 py-3 bg-gray-800'>
            <div></div>
            <div className='bg-gray-900 px-7 py-2 rounded-lg text-gray-200 text-sm'>Hi Ihthishaam</div>
        </header>
    )
}